module.exports = __webpack_public_path__ + "static/media/map.d2184666.png";